// extracted by mini-css-extract-plugin
export default {"dialogs":"Dialogs_dialogs__+NJcQ","empty":"Dialogs_empty__jga0X"};